module.exports = __webpack_public_path__ + "static/media/strikethrough.6f983bcd.svg";